import { Box } from '@hopskipdrive/react-components';
import { colorTokens } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const FareDetailsContainer = styled(Box)`
  background-color: rgba(2, 136, 209, 0.04);
  border: 1px solid rgba(2, 136, 209, 0.3);
  border-radius: 4px;
  padding: 0.75rem;
  color: ${colorTokens.text.medium};
`;

export const PerRiderFareDetailsContainer = styled(Box)`
  display: flex;
  border: 1px solid rgba(2, 136, 209, 0.3);
  border-radius: 4px;
  color: ${colorTokens.text.medium};
`;

export const RidersFareContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  background-color: #fff;
  border-right: 1px solid rgba(2, 136, 209, 0.3);
  padding: 0.75rem;
  color: ${colorTokens.text.medium};
`;

export const OtherValuesContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  background-color: rgba(2, 136, 209, 0.04);
  padding: 0.75rem;
  color: ${colorTokens.text.medium};
`;

export const HighlightedFare = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid rgba(2, 136, 209, 0.3);
  border-left: 1px solid #fff;
  border-radius: 0 4px 4px 0;
  background-color: #fff;
  margin-left: -14px;
  padding: 0 0.75rem;
`;
